/**
 * The LayerManager wraps your application and creates two adjacent divs for
 * rendering your application and housing Layers.
 */
import { ComponentChildren } from 'preact';
import { useCallback, useState } from 'preact/compat';
import { LayerContext, LayerContextProps, LayerPriority } from './LayerContext';
import LayerHost from './LayerHost';
import TopLayerHost from './TopLayerHost';

type LayerManagerProps = {
  children?: ComponentChildren;
};

export function LayerManager({ children }: LayerManagerProps) {
  const [defaultHost, setDefaultHost] = useState<Element>();
  const [defaultTopHost, setDefaultTopHost] = useState<Element>();
  //const context = useContext(LayerContext);
  const defaultHostRef = useCallback((el: Element | null) => {
    // ref callbacks fire after the component has been unnmounted so we do not
    // want to set state in this use-case
    if (el !== null) {
      setDefaultHost(el);
    }
  }, []);

  const defaultTopHostRef = useCallback((el: Element | null) => {
    // ref callbacks fire after the component has been unnmounted so we do not
    // want to set state in this use-case
    if (el !== null) {
      setDefaultTopHost(el);
    }
  }, []);

  return (
    <LayerContext.Consumer>
      {(value: LayerContextProps) => {
        let defaultHostContext = {};
        if (defaultHost && defaultTopHost) {
          defaultHostContext = {
            priority: undefined,
            getHost: (priority: LayerPriority) => {
              return priority === 'top' ? defaultTopHost : defaultHost;
            }
          };
        }
        const layerContext = value.getHost ? value : defaultHostContext;
        return (
          <LayerContext.Provider value={layerContext}>
            {children}
            {!value.getHost && <LayerHost ref={defaultHostRef} />}
            {!value.getHost && <TopLayerHost ref={defaultTopHostRef} />}
          </LayerContext.Provider>
        );
      }}
    </LayerContext.Consumer>
  );
}
